import { Input } from 'antd';
import { Controller } from 'react-hook-form';
import { FormControllerProps } from '../types';

export function FormController(props: FormControllerProps) {
  return (
    <>
      <Controller
        control={props.control}
        name={props.name}
        render={
          props.render
            ? props.render
            : ({ field }) => (
                <Input
                  size='large'
                  variant='filled'
                  className='py-4 px-5 rounded-2xl'
                  {...field}
                  {...props.inputProps}
                />
              )
        }
        rules={props.rules || {}}
      />
      {props.error && <span className='text-error'>{props.error}</span>}
    </>
  );
}
